import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import NavbarLeft from "../Components/NavbarLeft";
import "react-widgets/styles.css";
import Combobox from "react-widgets/Combobox";
import { ReactComponent as BackArrow } from "../../assets/navbar/BackArrow.svg";

// REDUX
import { useDispatch, useSelector } from "react-redux";
import { fetchCiqualCategories } from "../../redux/actions/ciqualCategoriesActions";
import { createAnalysis, clear_create_analysis_result } from "../../redux/actions/analysisActions";
import ComponentLoading from "../../commonComponents/ComponentLoading";
import { setUserOnboardingStep, setUserOnboardingStepLocal } from "../../redux/actions/userActions";
import firebase, { auth } from "../../firebase/config";

const AnalysisProduceChoice = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  // REDUX
  const dispatch = useDispatch();
  const fetchCiqualCategories_rd = () => dispatch(fetchCiqualCategories());
  const createAnalysis_rd = (item) => dispatch(createAnalysis(item));
  const clear_create_analysis_result_rd = () => dispatch(clear_create_analysis_result());
  const ciqualCategories = useSelector((state) => state.ciqualCategories);
  const create_analysis_result = useSelector((state) => (state.analysis ? state.analysis.create_analysis_result : null));
  // const auth = useSelector((state) => state.firebase.auth);
  // const state = useSelector((state) => state);

  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const setUserOnboardingStep_rd = (item) => dispatch(setUserOnboardingStep(item));
  const setUserOnboardingStepLocal_rd = (item) => dispatch(setUserOnboardingStepLocal(item));
  const handleChangeOnboardingStep = (item) => {
    setUserOnboardingStep_rd(item);
    setUserOnboardingStepLocal_rd(item);
  };

  useEffect(() => {
    if (!ciqualCategories.ciqual_categories) {
      fetchCiqualCategories_rd();
    }
  }, []);

  // useEffect(() => {
  //   clear_create_analysis_result_rd();
  // }, []);

  useEffect(() => {
    // console.log("EFFECT create_analysis_result", create_analysis_result);
    if (create_analysis_result && create_analysis_result.status === "success") {
      clear_create_analysis_result_rd();
      navigate("/Analysis", { state: { from: "AnalysisProduceChoice" } });
      if (user_info.usage_info && user_info.usage_info.onboarding_step < 1) {
        handleChangeOnboardingStep(1);
      }
    }
  }, [create_analysis_result]);

  return (
    <>
      <NavbarLeft currentPage={2} />
      <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start ml-[25px]">
        <div className="w-full relative left-[70px] flex justify-start items-center">
          <Link to="/Home">
            <BackArrow />
          </Link>
          <p className="font-Poppins-SemiBold text-lg relative p-10">Analyser - Choix d'une référence</p>
        </div>
      </div>
      <div className="relative top-[250px] left-[400px] bg-white rounded-xl w-[640px] h-[350px] shadow border-[#F3F5F7] border-[1px]">
        <div className="relative top-[20px] left-[40px] w-[580px] h-[130px] flex items-center justify-start">
          {/* <div className="bg-green-200 h-[100px] w-[100px] ">AGRI BA LYSE</div> */}
          <img className="h-[100px] w-[100px]" alt="agribalyse_img" src={require("../../assets/analyse/agribalyse.png")} />
          <div className="h-[100px] relative left-[20px]">
            <h1 className="font-Poppins-SemiBold text-4xl">Choisir un produit de référence</h1>
            <p className="font-Poppins-Light text-sm flex text-center mt-[10px]">Nos templates sont pré-remplis avec la moyenne de</p>
            <p className="font-Poppins-Light text-sm flex text-center mt-[5px]">l'industrie.</p>
          </div>
        </div>
        <div className="relative left-[70px] top-[40px] h-[30px] w-[500px] shadow-xl mt-[30px]">
          <Combobox
            filter="contains"
            // data={ciqualCategories.ciqual_categories}
            data={ciqualCategories.ciqual_categories && ciqualCategories.ciqual_categories.sort((a, b) => a.alim_nom_fr.localeCompare(b.alim_nom_fr))}
            dataKey="id"
            textField="alim_nom_fr"
            disabled={loading ? true : false}
            onSelect={async (e) => {
              setLoading(true);
              await createAnalysis_rd({
                ciqual_category_id: e.id,
                tenant_id: auth.currentUser.tenantId.toLowerCase(),
                user_id: auth.currentUser.uid,
                // tenant_id: "orgatest-2qv0m",
                // user_id: "1mIv9HN0EgZqLi2CRYM5s6dWRaX2",
              });
              setLoading(false);
            }}
          />
        </div>
        {loading && <ComponentLoading height={35} style={"pt-[30px] w-[full] mt-[60px] flex items-center justify-center"} />}
      </div>
    </>
  );
};

// const mapStateToProps = state => ({
//   ciqual_categories: state.ciqual_categories
// });

// const mapDispatchToProps = (dispatch) => {
//   return {
//     createAnlysis: () => dispatch(createAnlysis()),
//     fetchCiqualCategories: () => dispatch(fetchCiqualCategories()),
//   };
// };

// export default connect(mapStateToProps, mapDispatchToProps)(AnalysisProduceChoice);

export default AnalysisProduceChoice;
